<div id="wait" *ngIf="isLoading">
  <mat-spinner></mat-spinner>
</div>

<div class="breathwork-container" *ngIf="!isLoading">
  <!-- Date Picker Section -->
  <div class="date-picker-section mt-3">
    <mat-form-field>
      <mat-label>Enter a date range</mat-label>
      <mat-date-range-input [rangePicker]="picker">
        <input matStartDate placeholder="Start date" [(ngModel)]="previousDate" #dateRangeStart>
        <input matEndDate placeholder="End date" [(ngModel)]="currentDate" #dateRangeEnd 
               (dateChange)="filterByDate(dateRangeStart, dateRangeEnd)">
      </mat-date-range-input>
      <mat-hint>MM/DD/YYYY – MM/DD/YYYY</mat-hint>
      <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-date-range-picker #picker></mat-date-range-picker>
    </mat-form-field>
  </div>

  <!-- Calendar Heatmap Section -->
  <div class="calendar-heatmap-section" *ngIf="calendarDays.length > 0">
    <div class="heatmap-container">
      <!-- Left Section: Total Count and Labels -->
      <div class="left-section">
        <div class="total-count-section">
          <h3 class="total-count-label">Number of Breathworks</h3>
          <div class="total-count-number">{{ totalBreathworks }}</div>
        </div>
        <div class="row-labels-section">
          <div class="row-label deep-breathing-label">Deep Breathing</div>
          <div class="row-label box-breathing-label">Box Breathing</div>
        </div>
      </div>

      <!-- Right Section: Calendar Heatmap -->
      <div class="right-section">
        <!-- Legend -->
        <div class="legend">
          <div class="legend-item">
            <span class="legend-color green"></span>
            <span class="legend-text">Deep Breathing</span>
          </div>
          <div class="legend-item">
            <span class="legend-color pink"></span>
            <span class="legend-text">Box Breathing</span>
          </div>
          <div class="legend-item">
            <span class="legend-color grey"></span>
            <span class="legend-text">No Entries</span>
          </div>
        </div>

        <!-- Scrollable Calendar Grid -->
        <div class="calendar-wrapper">
          <div class="calendar-blocks-container">
            <div class="calendar-column" *ngFor="let day of calendarDays">
              <div class="calendar-block-wrapper">
                <!-- Deep Breathing Block -->
                <div class="calendar-block" 
                     [ngClass]="getBlockClass(day.deepBreathing)"
                     [style.background-color]="day.deepBreathing > 0 ? '#4CAF50' : '#E0E0E0'"
                     (mouseenter)="day.deepBreathing > 0 && showTooltip($event, day, 'deep')"
                     (mouseleave)="hideTooltip()"
                     (mousemove)="day.deepBreathing > 0 && updateTooltipPosition($event)">
                  <span class="entry-text">{{ getEntryText(day.deepBreathing) }}</span>
                </div>
                
                <!-- Box Breathing Block -->
                <div class="calendar-block" 
                     [ngClass]="getBlockClass(day.boxBreathing)"
                     [style.background-color]="day.boxBreathing > 0 ? '#E91E63' : '#E0E0E0'"
                     (mouseenter)="day.boxBreathing > 0 && showTooltip($event, day, 'box')"
                     (mouseleave)="hideTooltip()"
                     (mousemove)="day.boxBreathing > 0 && updateTooltipPosition($event)">
                  <span class="entry-text">{{ getEntryText(day.boxBreathing) }}</span>
                </div>
              </div>
              
              <!-- Date Label -->
              <div class="date-label">{{ day.dayLabel }}</div>
            </div>
          </div>
          
          <!-- Month Indicators -->
          <div class="month-indicators-container">
            <div class="month-indicator" *ngFor="let monthGroup of monthGroups"
                 [style.left.px]="getMonthIndicatorLeft(monthGroup.startIndex)"
                 [style.width.px]="getMonthIndicatorWidth(monthGroup.dayCount)">
              <div class="month-indicator-line">
                <span class="month-indicator-arrow-left">←</span>
                <span class="month-indicator-name">{{ monthGroup.monthName }}</span>
                <span class="month-indicator-arrow-right">→</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Timeline Arrow -->
        
      </div>
    </div>
  </div>

  <!-- Tooltip -->
  <div class="tooltip-card" 
       *ngIf="tooltipVisible && tooltipData"
       [style.left.px]="tooltipPosition.x + 10"
       [style.top.px]="tooltipPosition.y + 10">
    <div class="tooltip-header">
      <div class="tooltip-type">{{ tooltipData.type }}</div>
      <div class="tooltip-date">{{ tooltipData.date }}</div>
    </div>
    <div class="tooltip-entries">
      <div class="tooltip-entry" *ngFor="let entry of tooltipData.entries">
        <div class="tooltip-entry-time">{{ entry.time }}</div>
        <div class="tooltip-entry-cycles">{{ entry.cycles }} cycles</div>
      </div>
    </div>
  </div>

  <!-- Yearly Summary Section -->
  <div class="yearly-summary-section" *ngIf="!isLoading">
    <div class="yearly-summary-header">
      <h2 class="yearly-summary-title">Yearly Summary</h2>
      <mat-form-field class="year-selector">
        <mat-label>Year</mat-label>
        <mat-select [(ngModel)]="selectedYear" (selectionChange)="onYearChange()">
          <mat-option *ngFor="let year of availableYears" [value]="year" [disabled]="isYearDisabled(year)">{{ year }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <!-- Deep Breathing Yearly Summary -->
    <div class="yearly-activity-section">
      <h3 class="yearly-activity-title">Number of Deep Breathing</h3>
      <div class="yearly-total">Year {{ selectedYear }}: {{ yearlyDeepBreathingTotal | number }}</div>
      
      <div class="yearly-heatmap">
        <div class="yearly-heatmap-container">
          <div class="yearly-heatmap-days">
            <!-- Single weekday column (Y-axis labels) -->
            <div class="yearly-weekday-column">
              <div class="yearly-weekday-spacer-top"></div>
              <div class="yearly-weekday-label" *ngFor="let wd of weekdayLabels">
                {{ wd }}
              </div>
            </div>

            <!-- All month grids to the right -->
            <div class="yearly-months-groups">
              <div class="yearly-month-wrapper" *ngFor="let month of yearlyDeepBreathingData">
                <!-- Month name above the grid -->
                <div class="yearly-month-header">
                  <span class="yearly-month-label">{{ month.monthName }}</span>
                </div>
                <!-- 7 rows = weekdays, columns = weeks -->
                <div class="yearly-month-group">
                  <div class="yearly-day-cell" 
                       *ngFor="let day of month.days"
                       [class.active]="day.hasActivity && day.dateStr"
                       [class.inactive]="!day.hasActivity || !day.dateStr"
                       [class.empty]="!day.dateStr">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Box Breathing Yearly Summary -->
    <div class="yearly-activity-section">
      <h3 class="yearly-activity-title">Number of Box Breathing</h3>
      <div class="yearly-total">Year {{ selectedYear }}: {{ yearlyBoxBreathingTotal | number }}</div>
      
      <div class="yearly-heatmap box-breathing-heatmap">
        <div class="yearly-heatmap-container">
          <div class="yearly-heatmap-days">
            <!-- Single weekday column (Y-axis labels) -->
            <div class="yearly-weekday-column">
              <div class="yearly-weekday-spacer-top"></div>
              <div class="yearly-weekday-label" *ngFor="let wd of weekdayLabels">
                {{ wd }}
              </div>
            </div>

            <!-- All month grids to the right -->
            <div class="yearly-months-groups">
              <div class="yearly-month-wrapper" *ngFor="let month of yearlyBoxBreathingData">
                <!-- Month name above the grid -->
                <div class="yearly-month-header">
                  <span class="yearly-month-label">{{ month.monthName }}</span>
                </div>
                <!-- 7 rows = weekdays, columns = weeks -->
                <div class="yearly-month-group">
                  <div class="yearly-day-cell box-breathing-cell" 
                       *ngFor="let day of month.days"
                       [class.active]="day.hasActivity && day.dateStr"
                       [class.inactive]="!day.hasActivity || !day.dateStr"
                       [class.empty]="!day.dateStr">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

